
import React from 'react';
import KYCManagement from '@/components/admin/KYCManagement';
import KYCAccessGuard from '@/components/KYCAccessGuard';

const KYCManagementPage = () => {
  return (
    <KYCAccessGuard requireDocuments={false}>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">KYC Verification</h1>
          <p className="text-muted-foreground">
            Review and verify user identity documents
          </p>
        </div>
        <KYCManagement />
      </div>
    </KYCAccessGuard>
  );
};

export default KYCManagementPage;
